import React, { useEffect, useState, useRef } from "react";
import "../../Modules/Tickets/Ticketslist.css";
import { useNavigate, useLocation } from "react-router-dom";
import { Spinner } from "react-bootstrap";
import { apiCall } from "../../services/api-service.js";
import subTicketIcon from "../../Assets/svg/sub-ticket-icon.svg";
import editIcon from "../../Assets/svg/edit.svg";
import editBlueIcon from "../../Assets/svg/edit_blue.svg";
import playIcon from "../../Assets/svg/play.svg";
import pauseIcon from "../../Assets/svg/pause.svg";
import plusIcon from "../../Assets/svg/plus_color.svg";
import assign from "../../Assets/svg/assign.svg";
import split from "../../Assets/svg/split.svg";
import clone from "../../Assets/svg/clone.svg";
import comment from "../../Assets/svg/add_comment.svg";
import attach from "../../Assets/svg/add_attach.svg";
import deleteIcon from "../../Assets/svg/trash_black.svg";
import editmaininfo from "../../Assets/svg/edit_main_info.svg";
import dropDownTriangle from "../../Assets/svg/drop_down_triangle.svg";
import arrowDown from "../../Assets/svg/arrow-down.svg";
import ExpectedDateUpdateModal from "./modal/expected-date-update.js";
import AssignTicketModal from "./modal/assign-ticket.js";
import AddCommentModal from "./modal/add-comment.js";
import AddAttachmentModal from "./modal/add-attachment.js";
import EditMainInfoModal from "./modal/edit-main-info.js";
import MultiSelectDropDown from "../common/searchbox/multi-select-dropdown.js";
import ticketIcon from "../../Assets/svg/ticket_icon.svg";
import { getEnabledFieldApi } from "./Ticketapi.js";

const STATUS_COLORS = {
  Open: "#9E9E9E",
  "In Progress": "#4CAF50",
  "In-Progress": "#4CAF50",
  Hold: "#FFC107",
  Closed: "#F44336",
  Completed: "#F44336",
};

const APPROVAL_COLORS = {
  Approved: "#4CAF50",
  Pending: "#FFC107",
  Rejected: "#F44336",
};

const PRIORITY_STYLES = {
  High: { bg: "#FFEBEE", text: "#F44336" },
  Medium: { bg: "#FFF3E0", text: "#FF9800" },
  Low: { bg: "#E8F5E9", text: "#4CAF50" },
  Critical: { bg: "#FFEBEE", text: "#B71C1C" },
};

const getPriorityStyle = (priority) => {
  if (!priority) return { bg: "#F5F5F5", text: "#9E9E9E" };
  const normalized = priority.charAt(0).toUpperCase() + priority.slice(1).toLowerCase();
  return PRIORITY_STYLES[normalized] || { bg: "#F5F5F5", text: "#9E9E9E" };
};

const DEFAULT_COLOR = "#9E9E9E";

const Tickettableview = ({ tableData, deleteTicket, rolePermission, onSelectCheckBox, clearAllCheckbox, selectedTab, setInProgressTicket, setUpdateStatus, cloneTicket, refreshList, selectedProjectOptions, handleProjectDropdownChange, selectedComponentOptions, handleComponentDropdownChange }) => {
  const [localTableData, setLocalTableData] = useState(tableData || []);
  const [fieldLabels, setFieldLabels] = useState({});
  const [enabledFields, setEnabledFields] = useState([]);
  const [mandatoryFields, setMandatoryFields] = useState([]);

  const getEnabledField = async () => {
    try {
      const response = await getEnabledFieldApi();
      if (response?.success === true) {
        setEnabledFields(response?.enabled_fields ?? []);
        setMandatoryFields(response?.mandatory_fields ?? []);
        setFieldLabels(response?.application_labels ?? response?.labels ?? {});
      }
    } catch (err) {
      console.error("Error fetching field labels:", err);
    }
  };

  const isFieldEnabled = (field) => {
    if (field === "Title" || field === "Project") return true;
    if (field === "Customer" || field === "Client Name") {
      return enabledFields.some((item) => item === "Customer" || item === "Client Name");
    }
    return enabledFields.some((item) => item === field);
  };

  const isFieldMandatory = (field) => {
    if (field === "Title" || field === "Project") return true;
    if (!isFieldEnabled(field)) return false;
    if (field === "Customer" || field === "Client Name") {
      return mandatoryFields.some((item) => item === "Customer" || item === "Client Name");
    }
    return mandatoryFields.some((item) => item === field);
  };

  useEffect(() => {
    getEnabledField();
  }, []);

  const getFieldLabel = (fieldKey, defaultLabel = fieldKey) => {
    let custom = fieldLabels?.[fieldKey];
    if ((!custom || typeof custom !== "string" || custom.trim() === "") && (fieldKey === "Customer" || fieldKey === "Client Name")) {
      custom = fieldLabels?.["Customer"] || fieldLabels?.["Client Name"];
    }
    if (custom && typeof custom === "string" && custom.trim() !== "") {
      return custom.trim();
    }
    return defaultLabel;
  };

  useEffect(() => {
    setLocalTableData(tableData || []);
    setSelectedIds([]);
    setExpandedIds([]);
    setHoveredId(null);
    setActiveDropdown(null);
  }, [tableData]);

  const [hoveredId, setHoveredId] = useState(null);
  const navigate = useNavigate();
  const location = useLocation();
  const { parentTicketId } = location.state || {};
  const [selectedIds, setSelectedIds] = useState([]);
  const [showExpectedDateModal, setShowExpectedDateModal] = useState(false);
  const [showAssignModal, setShowAssignModal] = useState(false);
  const [showCommentModal, setShowCommentModal] = useState(false);
  const [showAttachmentModal, setShowAttachmentModal] = useState(false);
  const [showEditMainModal, setShowEditMainModal] = useState(false);
  const [expectedDateTicket, setExpectedDateTicket] = useState(null);
  const [assignTicket, setAssignTicket] = useState(null);
  const [commentTicket, setCommentTicket] = useState(null);
  const [attachmentTicket, setAttachmentTicket] = useState(null);
  const [editMainTicket, setEditMainTicket] = useState(null);
  const [activeDropdown, setActiveDropdown] = useState(null);
  const [isDropdownUp, setIsDropdownUp] = useState(false);
  const [dropdownCoords, setDropdownCoords] = useState(null);
  const [expandedIds, setExpandedIds] = useState([]);
  const [subTicketsData, setSubTicketsData] = useState({});
  const [loadingSubTickets, setLoadingSubTickets] = useState({});
  const dropdownRef = useRef(null);
  const allExpandedSubTicketIds = expandedIds.flatMap((id) => subTicketsData[String(id)]?.map((sub) => String(sub.id)) || []);

  useEffect(() => {
    setExpandedIds([]);
    setSubTicketsData({});
  }, [selectedTab]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setActiveDropdown(null);
        setHoveredId(null);
      } else if (!dropdownRef.current) {
        setActiveDropdown(null);
      }
    };
    const handleScroll = () => {
      setActiveDropdown(null);
      setHoveredId(null);
    };
    document.addEventListener("mousedown", handleClickOutside);
    window.addEventListener("scroll", handleScroll, true);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
      window.removeEventListener("scroll", handleScroll, true);
    };
  }, []);

  useEffect(() => {
    if (clearAllCheckbox === true) {
      setSelectedIds([]);
    }
  }, [clearAllCheckbox]);

  useEffect(() => {
    onSelectCheckBox(selectedIds);
  }, [selectedIds]);

  useEffect(() => {
    if (parentTicketId) {
      const pid = Number(parentTicketId);
      const strPid = String(parentTicketId);
      if (!expandedIds.map(String).includes(strPid)) {
        setExpandedIds((prev) => [...prev, pid]);
      }
      const fetchSubTickets = async () => {
        if (!subTicketsData[strPid]) {
          setLoadingSubTickets((prev) => ({ ...prev, [strPid]: true }));
          try {
            const response = await apiCall("get", `ticket/subtickets/${strPid}`);
            if (response?.status === 200 && response.data?.success === true) {
              setSubTicketsData((prev) => ({ ...prev, [strPid]: response.data.tickets }));
            }
          } catch (err) {
            console.error("Error fetching sub-tickets:", err);
          } finally {
            setLoadingSubTickets((prev) => ({ ...prev, [strPid]: false }));
          }
        }
      };
      fetchSubTickets();
    }
  }, [parentTicketId]);

  const refetchSubTickets = async (parentId) => {
    if (!parentId) return;
    const strParentId = String(parentId);
    try {
      const response = await apiCall("get", `ticket/subtickets/${strParentId}`);
      if (response?.status === 200 && response.data?.success === true) {
        setSubTicketsData((prev) => ({ ...prev, [strParentId]: response.data.tickets }));
      }
    } catch (err) {
      console.error("Error refetching sub-tickets:", err);
    }
  };

  useEffect(() => {
    if (expandedIds.length > 0) {
      expandedIds.forEach((pid) => {
        refetchSubTickets(pid);
      });
    }
  }, [tableData, expandedIds]);

  const selectableData = localTableData.filter((item) => item && item.id != null && !allExpandedSubTicketIds.includes(String(item.id)));

  const toggleSelect = async (id) => {
    const isCurrentlySelected = selectedIds.includes(id);
    if (isCurrentlySelected) {
      setSelectedIds((prev) => prev.filter((i) => i !== id));
      return;
    }

    const item = localTableData.find((t) => t.id === id);
    const hasSubtickets = item?.is_subticket === true;

    if (!hasSubtickets) {
      setSelectedIds((prev) => [...prev, id]);
      return;
    }

    let subTicketIds = [];
    if (subTicketsData[id]) {
      subTicketIds = subTicketsData[id].map((t) => t.id);
      setSelectedIds((prev) => {
        const newSelection = [...prev, id];
        subTicketIds.forEach((sid) => {
          if (!newSelection.includes(sid)) {
            newSelection.push(sid);
          }
        });
        return newSelection;
      });
    } else {
      try {
        const response = await apiCall("get", `ticket/subtickets/${id}`);
        if (response?.status === 200 && response.data?.success === true) {
          const fetchedSubs = response.data.tickets || [];
          setSubTicketsData((prev) => ({ ...prev, [id]: fetchedSubs }));
          subTicketIds = fetchedSubs.map((t) => t.id);
          setSelectedIds((prev) => {
            const newSelection = [...prev, id];
            subTicketIds.forEach((sid) => {
              if (!newSelection.includes(sid)) {
                newSelection.push(sid);
              }
            });
            return newSelection;
          });
        } else {
          setSelectedIds((prev) => [...prev, id]);
        }
      } catch (err) {
        console.error("Error fetching sub-tickets during selection:", err);
        setSelectedIds((prev) => [...prev, id]);
      }
    }
  };

  const toggleSelectAll = () => {
    if (selectedIds.length >= selectableData.length) {
      setSelectedIds([]);
    } else {
      const mainIds = selectableData.map((row) => row.id);
      const allSubIds = [];
      mainIds.forEach((pid) => {
        const subs = subTicketsData[pid] || [];
        subs.forEach((sub) => {
          allSubIds.push(sub.id);
        });
      });
      setSelectedIds([...mainIds, ...allSubIds]);
    }
  };

  const handleRowClick = (e, item) => {
    if (rolePermission?.view_permission === false) {
      e.preventDefault();
      return;
    }
    navigate(`/ticket/view/${item.id}`, { state: { listing_type: selectedTab } });
  };

  const handleEdit = (item, extraState = {}) => {
    if (rolePermission?.edit_permission !== true) return;
    navigate("/ticket/add", {
      state: { id: item.id, rolePermission, ...extraState },
    });
  };

  const handleDirectStatusUpdate = async (item, status) => {
    const isSub = item.main_ticketid || item.is_sub === true;
    if (isSub && item.main_ticketid) {
      setSubTicketsData((prev) => {
        const parentId = item.main_ticketid;
        const currentSubTickets = prev[parentId] || [];
        const updated = currentSubTickets.map((t) => (t.id === item.id ? { ...t, status: status } : t));
        return { ...prev, [parentId]: updated };
      });
    } else {
      setLocalTableData((prev) => prev.map((t) => (t.id === item.id ? { ...t, status: status } : t)));
    }
    setHoveredId(item.id);
    try {
      const data = {
        status: status,
        description: "", // Bypassing description for Start/Resume/Hold
      };
      const response = await apiCall("put", `ticket/status_update/${item.id}`, data);
      if (response?.status === 200 && response.data?.success === true) {
        refreshList?.();
        if (isSub && item.main_ticketid) {
          refetchSubTickets(item.main_ticketid);
        }
      } else {
        if (isSub && item.main_ticketid) {
          refetchSubTickets(item.main_ticketid);
        } else {
          setLocalTableData(tableData);
        }
      }
    } catch (err) {
      if (isSub && item.main_ticketid) {
        refetchSubTickets(item.main_ticketid);
      } else {
        setLocalTableData(tableData);
      }
      console.error("Error updating status:", err);
    }
  };

  const handleStartStatus = (e, item) => {
    e.stopPropagation();
    handleDirectStatusUpdate(item, "In Progress");
  };

  const handleClone = (e, item) => {
    e.stopPropagation();
    cloneTicket?.(item);
  };

  const getStatusColor = (status) => STATUS_COLORS[status] || DEFAULT_COLOR;
  const getApprovalColor = (status) => APPROVAL_COLORS[status] || DEFAULT_COLOR;

  const isEditable = (item) => rolePermission?.edit_permission === true && (item.status === "Open" || item.status === "In Progress" || item.status === "In-Progress" || item.status === "Hold");

  const isDeletable = (item) => rolePermission?.delete_permission === true && item.status === "Open";

  const toggleExpand = async (e, id) => {
    e.stopPropagation();
    const strId = String(id);
    if (expandedIds.map(String).includes(strId)) {
      setExpandedIds((prev) => prev.filter((i) => String(i) !== strId));
    } else {
      setExpandedIds((prev) => [...prev, id]);
      if (!subTicketsData[strId]) {
        setLoadingSubTickets((prev) => ({ ...prev, [strId]: true }));
        try {
          const response = await apiCall("get", `ticket/subtickets/${strId}`);
          if (response?.status === 200 && response.data?.success === true) {
            setSubTicketsData((prev) => ({ ...prev, [strId]: response.data.tickets }));
          }
        } catch (err) {
          console.error("Error fetching sub-tickets:", err);
        } finally {
          setLoadingSubTickets((prev) => ({ ...prev, [strId]: false }));
        }
      }
    }
  };

  const renderRow = (item, isSubRow = false, index = null) => {
    const isExpanded = expandedIds.map(String).includes(String(item.id));
    return (
      <div
        key={item.id}
        style={{ position: "relative" }}
        onMouseEnter={() => {
          setHoveredId(item.id);
          if (activeDropdown && activeDropdown !== item.id) {
            setActiveDropdown(null);
          }
        }}
        onMouseLeave={() => {
          setHoveredId(null);
          if (activeDropdown === item.id) {
            setActiveDropdown(null);
          }
        }}
      >
        <div onClick={(e) => handleRowClick(e, item)} style={{ cursor: "pointer" }}>
          <div
            style={{
              paddingLeft: "6px",
              paddingRight: "6px",
              borderLeft: "3px solid transparent",
              position: "relative",
              display: "flex",
              alignItems: "center",
              width: "100%",
              backgroundColor: !isSubRow && isExpanded ? "#E3D5FF" : (hoveredId && hoveredId === item.id ? "#F8F9FD" : "#FFFFFF"),
              transition: "background-color 0.15s ease",
            }}
            className="body3"
          >
            <div style={{ width: "25px" }}>
              <div
                style={{ width: "40px" }}
                onClick={(e) => {
                  e.preventDefault();
                  e.stopPropagation();
                  toggleSelect(item.id);
                }}
              >
                <input type="checkbox" checked={selectedIds.includes(item.id)} readOnly />
              </div>
            </div>
            <p
              className="p13"
              style={{
                width: "130px",
                flex: "1",
                display: "flex",
                alignItems: "center",
                overflow: "hidden",
                paddingLeft: "10px",
                paddingRight: "10px",
                gap: "8px",
              }}
            >
              <span title={item.code} style={{ textOverflow: "ellipsis", whiteSpace: "nowrap", overflow: "hidden", minWidth: 0, flex: 1 }}>
                {item.code}
              </span>
            </p>
            <p
              className="p13"
              style={{
                width: "180px",
                minWidth: "180px",
                flex: "1.3",
                display: "flex",
                alignItems: "center",
                gap: "8px",
                overflow: "hidden",
                paddingRight: "10px",
                paddingLeft: "10px",
                boxSizing: "border-box",
              }}
            >
              <span title={item.title} style={{ textOverflow: "ellipsis", whiteSpace: "nowrap", overflow: "hidden", minWidth: 0, flex: 1 }}>
                {item.title}
              </span>
              <div style={{ display: "flex", alignItems: "center", gap: "6px", flexShrink: 0 }}>
                {(item.is_sub === true || isSubRow) && <img src={subTicketIcon} alt="sub-ticket" style={{ width: "16px", height: "16px" }} />}
                {!isSubRow && item.is_subticket === true && (
                  <div
                    onClick={(e) => toggleExpand(e, item.id)}
                    title="Show Subtickets"
                    style={{
                      width: "20px",
                      height: "20px",
                      borderRadius: "50%",
                      backgroundColor: "#6929E2",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      cursor: "pointer",
                    }}
                  >
                    <img src={arrowDown} alt="expand" style={{ width: "10px", filter: "brightness(0) invert(1)", transform: isExpanded ? "rotate(180deg)" : "rotate(0deg)", transition: "transform 0.2s" }} />
                  </div>
                )}
              </div>
            </p>
            <p
              className="p13"
              style={{
                width: "110px",
                flex: "0.8",
                display: "flex",
                alignItems: "center",
                paddingLeft: "10px",
                overflow: "hidden",
              }}
            >
              <span title={item.project} style={{ textOverflow: "ellipsis", whiteSpace: "nowrap", overflow: "hidden", flex: 1 }}>
                {item.project}
              </span>
            </p>
            <div
              style={{
                width: "90px",
                flex: "0.6",
                display: "flex",
                alignItems: "center",
                paddingLeft: "10px",
                overflow: "hidden",
              }}
            >
              {item.priority && (
                <div
                  style={{
                    backgroundColor: getPriorityStyle(item.priority).bg,
                    color: getPriorityStyle(item.priority).text,
                    padding: "4px 12px",
                    borderRadius: "100px",
                    fontSize: "11px",
                    fontWeight: "700",
                    fontFamily: "Satoshi",
                    textTransform: "uppercase",
                    display: "inline-flex",
                    alignItems: "center",
                    justifyContent: "center",
                    minWidth: "60px",
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                  }}
                  title={item.priority}
                >
                  {item.priority}
                </div>
              )}
            </div>
            <p
              className="p13"
              style={{
                width: "110px",
                flex: "0.8",
                display: "flex",
                alignItems: "center",
                paddingLeft: "10px",
                overflow: "hidden",
              }}
            >
              <span title={item.assigned_to} style={{ textOverflow: "ellipsis", whiteSpace: "nowrap", overflow: "hidden", flex: 1 }}>
                {item.assigned_to}
              </span>
            </p>
            <p
              className="p13"
              style={{
                width: "110px",
                flex: "0.8",
                display: "flex",
                alignItems: "center",
                paddingLeft: "10px",
                overflow: "hidden",
              }}
            >
              <span title={item.reporter} style={{ textOverflow: "ellipsis", whiteSpace: "nowrap", overflow: "hidden", flex: 1 }}>
                {item.reporter}
              </span>
            </p>

            <div
              style={{
                width: "120px",
                flex: "1",
                display: "flex",
                alignItems: "center",
                gap: "6px",
                paddingLeft: "10px",
              }}
            >
              <p
                className="p13 mb-0"
                style={{
                  textOverflow: "ellipsis",
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  minWidth: 0,
                }}
                title={item.date}
              >
                {item.date}
              </p>
              {isEditable(item) && (
                <div
                  onClick={(e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    setExpectedDateTicket(item);
                    setShowExpectedDateModal(true);
                  }}
                  style={{
                    display: hoveredId && hoveredId === item.id ? "flex" : "none",
                    alignItems: "center",
                    justifyContent: "center",
                    cursor: "pointer",
                    flexShrink: 0,
                    width: "24px",
                    height: "24px",
                    borderRadius: "50%",
                    border: "1px solid #E5E5E5",
                    background: "#FFFFFF",
                    marginLeft: "4px",
                  }}
                >
                  <img
                    src={editBlueIcon}
                    alt="edit-date"
                    style={{
                      width: "12px",
                      height: "12px",
                    }}
                  />
                </div>
              )}
            </div>
            {selectedTab === "approval" && (
              <div className="d-flex align-items-center" style={{ width: "120px", flex: "1", gap: "6px", paddingLeft: "10px" }}>
                <span
                  style={{
                    width: "12px",
                    height: "12px",
                    borderRadius: "4px",
                    backgroundColor: getApprovalColor(item.approval_status),
                    flexShrink: 0,
                  }}
                ></span>
                <p
                  className="p13 mb-0"
                  style={{
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                    flex: 1,
                    minWidth: 0,
                  }}
                  title={item.approval_status}
                >
                  {item.approval_status}
                </p>
              </div>
            )}
            <div style={{ width: "110px", flex: "0.8", paddingLeft: "10px" }} className="style-justify-start">
              <span
                style={{
                  width: "8px",
                  height: "8px",
                  borderRadius: "50%",
                  backgroundColor: getStatusColor(item.status),
                  flexShrink: 0,
                }}
              ></span>
              <p title={item.status} className="p13 ms-1 mb-0" style={{ textOverflow: "ellipsis", whiteSpace: "nowrap", overflow: "hidden", flex: 1 }}>
                {item.status}
              </p>
            </div>

            {/* Hover Action Buttons */}
            {(Boolean(hoveredId && hoveredId === item.id) || Boolean(activeDropdown && activeDropdown === item.id)) && (
              <div
                style={{
                  position: "absolute",
                  top: 0,
                  bottom: 0,
                  left: 0,
                  right: 0,
                  pointerEvents: "none",
                  zIndex: 3,
                  display: "flex",
                  justifyContent: "flex-end",
                  alignItems: "center",
                }}
              >
                <div
                  style={{
                    position: "sticky",
                    right: 0,
                    pointerEvents: "auto",
                    display: "flex",
                    alignItems: "center",
                    gap: "4px",
                    padding: "0px 6px 0px 12px",
                    background: !isSubRow && isExpanded ? "#E3D5FF" : (hoveredId && hoveredId === item.id ? "#F8F9FD" : "#FFFFFF"),
                    borderRadius: "100px 0 0 100px",
                    height: "34px",
                    transition: "background-color 0.15s ease",
                  }}
                >
                {(item.status === "Open" || item.status === "Hold" || item.status === "In Progress" || item.status === "In-Progress") && (
                  <div className="d-flex align-items-center" style={{ gap: "8px" }}>
                    {(item.status === "Open" || item.status === "Hold") && (
                      <div
                        onClick={(e) => {
                          e.stopPropagation();
                          if (item.status === "Open") {
                            handleStartStatus(e, item);
                          } else {
                            handleDirectStatusUpdate(item, "In Progress");
                          }
                        }}
                        style={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          width: "30px",
                          height: "30px",
                          borderRadius: "50%",
                          background: "#6929E2",
                          cursor: "pointer",
                        }}
                        title={item.status === "Open" ? "Start" : "Resume"}
                      >
                        <img src={playIcon} alt="status-action" style={{ width: "10px", height: "10px", filter: "brightness(0) invert(1)" }} />
                      </div>
                    )}

                    {(item.status === "In Progress" || item.status === "In-Progress") && (
                      <div
                        onClick={(e) => {
                          e.stopPropagation();
                          setInProgressTicket?.(item);
                          setUpdateStatus?.("Hold");
                        }}
                        style={{ display: "flex", alignItems: "center", justifyContent: "center", width: "30px", height: "30px", borderRadius: "50%", background: "#6929E2", cursor: "pointer" }}
                        title="Hold"
                      >
                        <img src={pauseIcon} alt="hold" style={{ width: "10px", height: "10px", filter: "brightness(0) invert(1)" }} />
                      </div>
                    )}

                    {(item.status === "In Progress" || item.status === "In-Progress" || item.status === "Hold") && (
                      <div
                        onClick={async (e) => {
                          e.stopPropagation();
                          try {
                            const response = await apiCall("get", `ticket/edit/${item.id}`);
                            if (response?.status === 200 && response.data?.success === true) {
                              const detail = response.data.ticket;
                              let currentEnabled = enabledFields;
                              let currentMandatory = mandatoryFields;
                              if (currentEnabled.length === 0 && currentMandatory.length === 0) {
                                const configRes = await getEnabledFieldApi();
                                if (configRes?.success) {
                                  currentEnabled = configRes.enabled_fields ?? [];
                                  currentMandatory = configRes.mandatory_fields ?? [];
                                  setEnabledFields(currentEnabled);
                                  setMandatoryFields(currentMandatory);
                                }
                              }
                              const checkEnabled = (f) => f === "Title" || f === "Project" || (f === "Customer" || f === "Client Name" ? (currentEnabled.includes("Customer") || currentEnabled.includes("Client Name")) : currentEnabled.includes(f));
                              const checkMandatory = (f) => (f === "Title" || f === "Project" || (f === "Customer" || f === "Client Name" ? (currentMandatory.includes("Customer") || currentMandatory.includes("Client Name")) : currentMandatory.includes(f))) && checkEnabled(f);

                              const errors = {};
                              if (!detail.project_id) errors.project_id = ["Update project to close ticket"];
                              if (checkEnabled("Level") && checkMandatory("Level") && !detail.component_id) {
                                errors.component_id = ["Update level(component) to close ticket"];
                              }
                              if (checkMandatory("Assign To") && !detail.assignee_id) {
                                errors.assignee = ["Update assignee to close ticket"];
                              }
                              if (checkMandatory("Expected Date") && !detail.expected) {
                                errors.expected_date = ["Update expected date to close ticket"];
                              }

                              if (Object.keys(errors).length > 0) {
                                handleEdit(item, { errors });
                              } else {
                                setInProgressTicket?.({ ...item, ...detail });
                                setUpdateStatus?.("Closed");
                              }
                            }
                          } catch (err) {
                            console.error("Error fetching ticket details:", err);
                          }
                        }}
                        style={{ display: "flex", alignItems: "center", justifyContent: "center", width: "30px", height: "30px", borderRadius: "50%", border: "1px solid #E5E5E5", background: "#F44336", cursor: "pointer" }}
                        title="Close"
                      >
                        <div style={{ width: "10px", height: "10px", backgroundColor: "#FFFFFF", borderRadius: "2px" }}></div>
                      </div>
                    )}
                  </div>
                )}

                {isEditable(item) && (
                  <div
                    onClick={(e) => {
                      e.stopPropagation();
                      handleEdit(item);
                    }}
                    className="action-icon-btn"
                    title="Edit"
                  >
                    <img src={editIcon} alt="edit" style={{ width: "14px", height: "14px" }} />
                  </div>
                )}

                {!(item.is_sub === true || isSubRow || item.main_ticketid) && item.status !== "Completed" && item.status !== "Closed" && (
                  <div
                    onClick={(e) => {
                      e.stopPropagation();
                      navigate("/ticket/add", { state: { parentTicketId: item.id } });
                    }}
                    className="action-icon-btn"
                    title="Add Sub-ticket"
                  >
                    <img src={plusIcon} alt="add-sub-ticket" style={{ width: "16px", height: "16px", filter: "brightness(0)" }} />
                  </div>
                )}

                {/* More Actions Button */}
                <div
                  onClick={(e) => {
                    e.stopPropagation();
                    const rect = e.currentTarget.getBoundingClientRect();
                    const spaceBelow = window.innerHeight - rect.bottom;
                    const spaceAbove = rect.top;
                    const shouldOpenUp = spaceBelow < 280 && spaceAbove > spaceBelow;
                    setIsDropdownUp(shouldOpenUp);
                    setDropdownCoords({
                      top: rect.bottom,
                      rectTop: rect.top,
                      right: rect.right,
                    });
                    setActiveDropdown(activeDropdown === item.id ? null : item.id);
                  }}
                  className="action-icon-btn"
                  style={{
                    background: activeDropdown && activeDropdown === item.id ? "#6929E2" : "#FFFFFF",
                  }}
                  title="More Actions"
                >
                  <span
                    style={{
                      fontSize: "20px",
                      fontWeight: "700",
                      color: activeDropdown && activeDropdown === item.id ? "#FFFFFF" : "#212129",
                      lineHeight: "1",
                      marginTop: "-4px",
                    }}
                  >
                    ⋮
                  </span>
                </div>

                {/* Dropdown Menu */}
                {Boolean(activeDropdown && activeDropdown === item.id && dropdownCoords) && (
                  <div
                    ref={dropdownRef}
                    style={{
                      position: "fixed",
                      top: isDropdownUp ? "auto" : `${dropdownCoords.top}px`,
                      bottom: isDropdownUp ? `${window.innerHeight - dropdownCoords.rectTop}px` : "auto",
                      right: `${window.innerWidth - dropdownCoords.right}px`,
                      background: "#FFFFFF",
                      borderRadius: "16px",
                      boxShadow: "0 8px 24px rgba(0,0,0,0.12)",
                      width: "200px",
                      zIndex: 1000,
                      padding: "8px",
                      border: "1px solid #F0F0F0",
                    }}
                  >
                    {[
                      {
                        key: "assign",
                        label: getFieldLabel("Assign To", "Assign"),
                        icon: assign,
                        onClick: (e) => {
                          e.stopPropagation();
                          setAssignTicket(item);
                          setShowAssignModal(true);
                        },
                      },
                      { key: "clone", label: "Clone Ticket", icon: clone, onClick: (e) => handleClone(e, item) },
                      {
                        key: "split",
                        label: "Split",
                        icon: split,
                        onClick: (e) => {
                          e.stopPropagation();
                          navigate("/ticket/add", { state: { split: true, parentTicketId: item.id } });
                        },
                      },
                      {
                        key: "comment",
                        label: "Add Comment",
                        icon: comment,
                        onClick: (e) => {
                          e.stopPropagation();
                          setCommentTicket(item);
                          setShowCommentModal(true);
                        },
                      },
                      {
                        key: "attachment",
                        label: (() => {
                          const attachLabel = getFieldLabel("Attachment", "Attach");
                          return attachLabel?.toLowerCase().startsWith("add")
                            ? attachLabel
                            : `Add ${attachLabel}`;
                        })(),
                        icon: attach,
                        onClick: (e) => {
                          e.stopPropagation();
                          setAttachmentTicket(item);
                          setShowAttachmentModal(true);
                        },
                      },
                      {
                        key: "edit_main",
                        label: "Edit Main Info",
                        icon: editmaininfo,
                        onClick: (e) => {
                          e.stopPropagation();
                          setEditMainTicket(item);
                          setShowEditMainModal(true);
                        },
                      },
                      { key: "delete", label: "Delete", icon: deleteIcon, onClick: () => isDeletable(item) && deleteTicket(item.id) },
                    ]
                      .filter((action) => {
                        const isFinished = item.status === "Completed" || item.status === "Closed";
                        const isSubTicket = item.is_sub === true || isSubRow || Boolean(item.main_ticketid);
                        if (action.key === "delete") return isDeletable(item);
                        if (action.key === "edit_main") return isEditable(item);
                        if (action.key === "assign" && isFinished) return false;
                        if (action.key === "split" && (isSubTicket || isFinished)) return false;
                        if (action.key === "comment" && isFinished) return false;
                        if (action.key === "attachment" && isFinished) return false;
                        return true;
                      })
                      .map((action, i) => (
                        <div
                          key={i}
                          onClick={(e) => {
                            e.stopPropagation();
                            action.onClick(e);
                            setActiveDropdown(null);
                          }}
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "12px",
                            padding: "10px 12px",
                            cursor: "pointer",
                            borderRadius: "10px",
                            transition: "background 0.2s ease",
                          }}
                          onMouseEnter={(e) => (e.currentTarget.style.background = "#E3D5FF")}
                          onMouseLeave={(e) => (e.currentTarget.style.background = "transparent")}
                        >
                          <img
                            src={action.icon}
                            alt={action.label}
                            style={{
                              width: "18px",
                              height: "18px",
                              filter: action.label === "Delete" ? "none" : "grayscale(1) brightness(0.5)",
                            }}
                          />
                          <span
                            style={{
                              fontSize: "14px",
                              fontWeight: "500",
                              color: action.color || "#212129",
                              fontFamily: "Satoshi",
                            }}
                          >
                            {action.label}
                          </span>
                        </div>
                      ))}
                  </div>
                )}
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    );
  };

  return (
    <>
      <div style={{ padding: "0px", backgroundColor: "#F6F7F8", overflowX: "auto", width: "100%" }}>
        <div style={{ borderRadius: "16px", overflow: "visible", minWidth: "1100px" }}>
          {/* Header Row Wrapper */}
          <div style={{ backgroundColor: "#FFFFFF", padding: "16px 0px", borderTopLeftRadius: "16px", borderTopRightRadius: "16px" }}>
            <div
              style={{
                display: "flex",
                width: "100%",
                padding: "0px 6px",
                border: "none",
                alignItems: "center",
                backgroundColor: "#F6F7F8",
              }}
              className="head3"
            >
              <div style={{ width: "25px" }}>
                <div style={{ width: "40px" }}>
                  <input type="checkbox" onChange={toggleSelectAll} checked={selectedIds.length === selectableData.length && selectableData.length > 0} />
                </div>
              </div>
              <p className="p13" style={{ width: "130px", flex: "1", display: "flex", alignItems: "center", paddingLeft: "10px", paddingRight: "10px", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
                Code
              </p>
              <p className="p13" style={{ width: "180px", minWidth: "180px", flex: "1.3", display: "flex", alignItems: "center", paddingRight: "10px", paddingLeft: "10px", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
                {getFieldLabel("Title", "Task Title")}
              </p>
              <div style={{ width: "110px", flex: "0.8", display: "flex", alignItems: "center", paddingLeft: "10px" }}>
                <MultiSelectDropDown
                  onDropdownChange={handleProjectDropdownChange}
                  apiUrl={process.env.REACT_APP_API_URL + `get_project`}
                  placeholder={getFieldLabel("Project", "Project")}
                  width="100%"
                  selectedOption={selectedProjectOptions}
                  customWrapperStyle={{ height: "auto" }}
                  customHeaderStyle={{
                    border: "none",
                    padding: 0,
                    fontSize: "13px",
                    fontWeight: "700",
                    color: "#212129",
                    fontFamily: "Satoshi",
                    background: "transparent",
                    justifyContent: "flex-start",
                    gap: "4px",
                    height: "auto",
                  }}
                  customArrow={<img src={dropDownTriangle} alt="arrow" style={{ width: "12px", marginLeft: "2px" }} />}
                />
              </div>
              <p className="p13" style={{ width: "90px", flex: "0.6", paddingLeft: "10px", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
                {getFieldLabel("Priority", "Priority")}
              </p>
              <p className="p13" style={{ width: "110px", flex: "0.8", paddingLeft: "10px", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
                {getFieldLabel("Assign To", "Assigned to")}
              </p>
              <p className="p13" style={{ width: "110px", flex: "0.8", paddingLeft: "10px", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
                {getFieldLabel("Reporter", "Reporter")}
              </p>
              <p className="p13" style={{ width: "120px", flex: "1", paddingLeft: "10px", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
                {getFieldLabel("Expected Date", "Expected date")}
              </p>
              {selectedTab === "approval" && (
                <p className="p13" style={{ width: "120px", flex: "1", paddingLeft: "10px", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }} title="Approval Status">
                  Approval Status
                </p>
              )}
              <p className="p13" style={{ width: "110px", flex: "0.8", paddingLeft: "10px", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
                Status
              </p>
            </div>
          </div>

          {/* Body Rows */}
          <div onMouseLeave={() => { setHoveredId(null); setActiveDropdown(null); }}>
            {localTableData.filter((item) => item?.id != null && !allExpandedSubTicketIds.includes(String(item.id))).length === 0 ? (
              <div
                style={{
                  padding: "60px 20px",
                  textAlign: "center",
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center",
                  backgroundColor: "#FFFFFF",
                  borderRadius: "16px",
                  marginTop: "8px",
                  minHeight: "260px",
                }}
              >
                <div
                  style={{
                    width: "56px",
                    height: "56px",
                    borderRadius: "50%",
                    backgroundColor: "#F3EDFF",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    marginBottom: "16px",
                  }}
                >
                  <img
                    src={ticketIcon}
                    alt="No tickets"
                    style={{ width: "24px", height: "24px" }}
                  />
                </div>
                <h5
                  style={{
                    fontFamily: "Satoshi",
                    fontSize: "16px",
                    fontWeight: "700",
                    color: "#212129",
                    marginBottom: "6px",
                  }}
                >
                  No tickets found
                </h5>
                <p
                  style={{
                    fontFamily: "Satoshi",
                    fontSize: "13px",
                    fontWeight: "400",
                    color: "#8790A1",
                    margin: 0,
                    maxWidth: "360px",
                  }}
                >
                  There are no tickets matching your current filter criteria.
                </p>
              </div>
            ) : (
              localTableData
                .filter((item) => item?.id != null && !allExpandedSubTicketIds.includes(String(item.id)))
                .map((item, index) => {
                  const isExpanded = expandedIds.map(String).includes(String(item.id));
                  const strId = String(item.id);
                  return (
                    <div
                      key={item.id}
                      style={{
                        marginBottom: isExpanded ? "12px" : "0px",
                        marginTop: isExpanded ? "12px" : "0px",
                        backgroundColor: "#FFFFFF",
                        borderRadius: isExpanded ? "16px" : "0px",
                        paddingTop: isExpanded ? "12px" : "0px",
                        paddingBottom: isExpanded ? "12px" : "0px",
                        overflow: "visible",
                        borderBottom: !isExpanded ? "1px solid #F0F0F0" : "none",
                        transition: "all 0.2s ease",
                        position: "relative",
                      }}
                    >
                      {renderRow(item, false, index)}
                      {isExpanded && (
                        <div style={{ backgroundColor: "#FFFFFF" }}>
                          {loadingSubTickets[strId] ? (
                            <div className="d-flex justify-content-center p-3">
                              <Spinner animation="border" size="sm" variant="primary" />
                            </div>
                          ) : (
                            subTicketsData[strId]?.map((sub) => renderRow(sub, true, index))
                          )}
                        </div>
                      )}
                    </div>
                  );
                })
            )}
          </div>
        </div>
      </div>
      {showExpectedDateModal && expectedDateTicket && (
        <ExpectedDateUpdateModal
          ticketDetail={expectedDateTicket}
          onSuccess={() => {
            setShowExpectedDateModal(false);
            refreshList?.();
            if (expectedDateTicket.main_ticketid) {
              refetchSubTickets(expectedDateTicket.main_ticketid);
            }
            setExpectedDateTicket(null);
          }}
          onHide={() => {
            setShowExpectedDateModal(false);
            setExpectedDateTicket(null);
          }}
        />
      )}
      {showAssignModal && assignTicket && (
        <AssignTicketModal
          ticketDetail={assignTicket}
          onSuccess={() => {
            setShowAssignModal(false);
            refreshList?.();
            if (assignTicket.main_ticketid) {
              refetchSubTickets(assignTicket.main_ticketid);
            }
            setAssignTicket(null);
          }}
          onHide={() => {
            setShowAssignModal(false);
            setAssignTicket(null);
          }}
        />
      )}
      {showCommentModal && commentTicket && (
        <AddCommentModal
          ticketDetail={commentTicket}
          onSuccess={() => {
            setShowCommentModal(false);
            refreshList?.();
            if (commentTicket.main_ticketid) {
              refetchSubTickets(commentTicket.main_ticketid);
            }
            setCommentTicket(null);
          }}
          onHide={() => {
            setShowCommentModal(false);
            setCommentTicket(null);
          }}
        />
      )}
      {showAttachmentModal && attachmentTicket && (
        <AddAttachmentModal
          ticketDetail={attachmentTicket}
          onSuccess={() => {
            setShowAttachmentModal(false);
            refreshList?.();
            if (attachmentTicket.main_ticketid) {
              refetchSubTickets(attachmentTicket.main_ticketid);
            }
            setAttachmentTicket(null);
          }}
          onHide={() => {
            setShowAttachmentModal(false);
            setAttachmentTicket(null);
          }}
        />
      )}
      {showEditMainModal && editMainTicket && (
        <EditMainInfoModal
          ticketDetail={editMainTicket}
          onSuccess={() => {
            setShowEditMainModal(false);
            refreshList?.();
            if (editMainTicket.main_ticketid) {
              refetchSubTickets(editMainTicket.main_ticketid);
            }
            setEditMainTicket(null);
          }}
          onHide={() => {
            setShowEditMainModal(false);
            setEditMainTicket(null);
          }}
        />
      )}
    </>
  );
};

export default Tickettableview;
